import { useEffect } from 'react';
import { handleError } from '../../utils/apiUtils';
import windowService from '../../services/windowService';

export const SilentRedirect = () => {
  const userManager = window.getUserManager?.();

  useEffect(() => {
    if (!userManager) return;
    userManager.signinSilentCallback().catch(error => {
      handleError(error);
      windowService.redirectTo('/login');
    });
  }, [userManager]);

  return null;
};
